import { jsx as _jsx } from "react/jsx-runtime";
import { ExtraSmallFab } from "../../Buttons/ExtraSmallFAB";
import CloseIcon from "@mui/icons-material/Close";
import { useTheme } from "@mui/material";
export const ItemDetailCloseButton = ({ onClick }) => {
    const theme = useTheme();
    return (_jsx(ExtraSmallFab, { icon: CloseIcon, "aria-label": "close", onClick: onClick, sx: {
            position: "absolute",
            top: theme.spacing(1.5),
            right: theme.spacing(1.5),
            padding: "3px",
        } }));
};
